import {
    Button,
    Container,
    Form,
    FormGroup,
    Message,
    Segment,
    SegmentContent,
    SegmentHeader,
    Toggle,
} from '@/platform/ui';
import { useForm, usePage } from '@inertiajs/react';
import Navigation from './components/Navigation';

const CustomerSettingView = () => {
    const { auth, settings } = usePage().props;
    const { data, setData, patch, processing } = useForm(settings || {});

    const handleSubmit = () => {
        patch(
            `/customers/${auth?.user?.selected_customer_id}/services/lkv/settings/customers`
        );
    };

    return (
        <Container fluid>
            <Navigation />

            <Segment>
                <SegmentHeader
                    header='Klant instellingen'
                    subheader='Hier kunt u de instellingen van de klant aanpassen.'
                />
                <SegmentContent>
                    <Form onSubmit={handleSubmit}>
                        <FormGroup>
                            <Message
                                variant='info'
                                title='Bewaartermijn'
                                content='De standaard bewaartermijn is 4 jaar. Neem contact op met de ondersteuning om deze instelling te wijzigen.'
                            />

                            <Toggle
                                label='Interne meldingen inschakelen'
                                checked={data?.notifications_enabled || false}
                                onChange={checked =>
                                    setData(
                                        'notifications_enabled',
                                        checked ? 1 : 0
                                    )
                                }
                            />

                            <div className='flex justify-end'>
                                <Button
                                    variant='primary'
                                    type='submit'
                                    loading={processing}
                                >
                                    Opslaan
                                </Button>
                            </div>
                        </FormGroup>
                    </Form>
                </SegmentContent>
            </Segment>
        </Container>
    );
};

export default CustomerSettingView;
